import React from 'react';

import { ServiceContextType } from './common.types';

export const ServiceContext = React.createContext({} as ServiceContextType);
